<template>
  <div class="item-base">
    <div class="item-title">
        <span>全部分类</span>
      </div>
    <div class="item-content" v-for="item in result" :key="item.id" v-if="result">
      <span class="span">
        {{item.name}}
      </span>
      <div class="detail">
        <div  v-for="t in item.childClassify" :key="t.id" class="second">{{t.name}}<i class="el-icon-arrow-right"></i>
            <div v-for="s in t.childClassify" :key="s.id" @click="GoodTo(s.id)" class="third el-tag-info">
              {{s.name}}
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductClassify",
  data(){
    return{
      result:{}  ,
    }
  },
  created() {
    this.GetClassify()
  },
  methods:{
    GoodTo(id){
      this.$router.push('/product/list/'+id)
    },
    GetClassify(){
      this.$axios.get('/api/productClassify/getTree').then(res=>{
        this.result=res.data.data
      })
    }
  }
}

</script>

<style lang="less" scoped>
.item-base{
  width: 200px;
  min-width: 200px;
  height: 50.9vh;
  background: #FFFFFF;
  border: 1px solid #188ACB;
  position: relative;
  .item-title{
    padding: 15px 0;
    span{
      padding-left: 10%;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
    }
  }
  .item-content{
    &:hover{
      .span{
        color: #188ACB;
      }
      background: rgba(24, 138, 203, 0.15);
      .detail{
        display: block;
      }
    }
    .detail{
      display: none;
      position: absolute;
      top: -1px;
      width: 1000px;
      min-width: 900px;
      left: 200px;
      height: 50.9vh;
      background: #FFFFFF;
      border: 2px solid #188ACB;
      z-index: 666;
      .second{
        padding-left: 5px;
      }
      .third{
        padding-left: 15px;
      }
    }
    span{
      display: block;
      height: 21px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      line-height: 21px;
      padding-left: 10%;
    }
  }
}
</style>